import axiosClient from './axiosClient';

export async function fetchPageData(url, allItems = []) {
  const secureUrl = url.startsWith('http://') ? url.replace('http://', 'https://') : url;

  const response = await axiosClient.get(secureUrl);
  const items = [...allItems, ...response.data.results];
  
  if (response.data.next) {
    return fetchPageData(response.data.next, items);
  } else {
    return items;
  }
}